import React from "react";
import { WrappedFieldProps } from "redux-form";
import LensIcon from "material-ui-icons/Lens";
import TextInput from "./TextInput";
import { Common } from "./Common";

interface ExtendedFieldProps {
    minCount?: number;
    maxCount?: number;
    adornment?: string;
    inputProps?:
    | React.TextareaHTMLAttributes<HTMLTextAreaElement>
    | React.InputHTMLAttributes<HTMLInputElement>;
    showCount?: boolean;
    onExtraBlur?: Function;
    // required?: boolean;
}

const renderTextfield = (
    props: Common & WrappedFieldProps & ExtendedFieldProps
) => {
    const {
        input,
        meta,
        style,
        adornment,
        inputProps,
        label,
        meta: { touched, error, warning },
        required,
        maxCount,
        showCount,
        ...nonprops
    } = props;

    const maxLen = maxCount || 250;

    const currentLen = input.value ? input.value.length : 0;

    const mergedInputProps = {
        maxLength: maxLen,
        ...inputProps,
    };

    // If there's an error from Redux Form, show that in helperText;
    // otherwise, optionally show the character count
    const helperTxt = touched && error
        ? error
        : showCount
            ? `${currentLen}/${maxLen}`
            : undefined;

    const mergedStyles = {
        ...style,
        fontSize: "1.35em",
    } as React.CSSProperties;

    return (
        <div>
            <TextInput
                {...nonprops}
                {...input}
                label={label || ""}
                adornment={adornment}
                style={mergedStyles}
                error={meta.touched && meta.error}
                fullWidth={true}
                inputProps={mergedInputProps}
                required={required}
                helperText={helperTxt}
            />
        </div>
    );
};

export default renderTextfield;



// WEBPACK FOOTER //
// ./src/components/form/RenderTextField.tsx